import React__default from 'react';
import { Typography, Badge } from '@mui/material';
import DefaultIcon from '../../DefaultIcon/index.js';
import CriteriaResult from '../CriteriaResult/index.js';

var ResultCategory = function (_a) {
    var title = _a.title, criteriaResults = _a.criteriaResults, _b = _a.errorNumber, errorNumber = _b === void 0 ? 0 : _b, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, { variant: "h5", sx: {
                paddingTop: 1,
                paddingBottom: 1,
                color: "#54616c",
                fontWeight: "500"
            } },
            React__default.createElement(Badge, { color: "error", badgeContent: errorNumber, sx: {
                    "& .MuiBadge-badge": {
                        right: "-11px",
                        top: "5px"
                    }
                } }, title)), criteriaResults === null || criteriaResults === void 0 ? void 0 :
        criteriaResults.map(function (criteriaResult) { return (React__default.createElement(CriteriaResult, { key: criteriaResult.criteriaLabel, criteriaLabel: criteriaResult.criteriaLabel, isValid: criteriaResult.isValid, criteriaTab: criteriaResult.criteriaTab, helper: criteriaResult.helper, additionalInformation: criteriaResult.additionalInformation, KIcon: KIcon, applyWarningColor: criteriaResult.applyWarningColor })); })));
};

export { ResultCategory as default };
//# sourceMappingURL=index.js.map
